import LoggingAPI from "@/api/logging";
import { useUpdatePreservation } from "../preservations.query";
import {
  DefaultPreservationForm,
  DefaultPreservationFormData,
} from "./DefaultPreservationForm";
import { useSnackbar, VariantType } from "notistack";
import { usePermissions } from "@/hooks";

export type EditPreservationFormProps = {
  onCancel?: () => void;
  onSubmit?: (
    formData: DefaultPreservationFormData,
    diffData?: Partial<DefaultPreservationFormData>
  ) => void;
  defaultFormData: {
    case_id: number;
    uuid: string;
  } & Partial<DefaultPreservationFormData>;
};

export const EditPreservationForm: React.FC<EditPreservationFormProps> = ({
  onCancel,
  onSubmit,
  defaultFormData,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = usePermissions();
  const mutation = useUpdatePreservation({
    onSuccess: (data) => {
      enqueueSnackbar(`Preservation Updated.`, {
        variant: "success" as VariantType,
      });

      LoggingAPI.createLog({
        case_id: defaultFormData.case_id,
        user_id: currentUser.user_id,
        message: `Updated preservation: ${data?.data?.name}`,
        event: "preservation:update",
        object_type: "preservation",
        object_uuid: data?.data?.uuid,
      });
    },
    onError: () => {
      enqueueSnackbar(`Failed to update preservation.`, {
        variant: "error" as VariantType,
      });
    },
  });

  const handleSubmit = (
    formData: DefaultPreservationFormData,
    diffData?: Partial<DefaultPreservationFormData>
  ) => {
    mutation.mutate(
      {
        ...diffData,
        uuid: defaultFormData.uuid,
      },
      {
        onSuccess: () => {
          onSubmit?.(formData, diffData);
        },
      }
    );
  };

  return (
    <div>
      <DefaultPreservationForm
        title="Edit Preservation"
        isPending={mutation.isPending}
        onCancel={onCancel}
        onSubmit={handleSubmit}
        defaultFormData={{
          name: "",
          ...defaultFormData,
        }}
      />
    </div>
  );
};
